<template>
  <div class="bussiness_stat" >
    <el-divider content-position="left">财务记账统计</el-divider>
    <div>
      <el-row class="mb-10" style="margin-top: 0">
        <el-col :span="8" style="display: flex">
          <span class="count"  style="display: inline-block; ">企业交接出去（{{thisTotal.date + '年度）：' + outDestory.out_other + ' 家'}}</span>
        </el-col>
        <el-col :span="8" style="display: flex">
          <span class="count"  style="display: inline-block; "> 企业注销（{{thisTotal.date + '年度）：' + outDestory.destory + ' 家'}}</span>
        </el-col>
      </el-row>
    </div>
    <div class="ranking_list public">
      <el-row style="width: 100%"  :gutter="30">
          <el-col :span="8" :xl="6" >
          <div class="col_ranking">
            <div class="ranking_title" style="margin-bottom: .4rem">商机创建排名（{{createTotal.date}}）</div>
            <el-tabs>
              <el-col :span="24" class="tr">
                <div>
                  <el-date-picker
                    v-model="createTimer"
                    type="month"
                    size="mini"
                    format="yyyy 年 MM 月"
                    value-format="yyyy-MM"
                    @change="pickerDataChange"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </div>
              </el-col>
              <div class="tabs_top public">
                <span class="count" style="width: 10%">排名</span>
                <span class="count count_name" style="width: 40%">姓名</span>
                <span class="count count_num" style="width: 50%">创建数量</span>
              </div>
              <div class="m-tabs-content" >
                <div
                  v-for="(item, index) in createRanking"
                  :key="index"
                  class="tabs_top public"
                  style="border-bottom: 1px solid #eeeeee">
                  <span  class="count" style="width: 10%">{{index + 1}}</span>
                  <span  class="count count_name" style="width: 40%">{{item.create_user ? item.create_user.username : ''}}</span>
                  <span  class="count count_name" style="width: 50%">{{item.count}}</span>
                </div>
              </div>
            </el-tabs>
            <div class="tabs_position">
              <span></span>
              <span>总计:{{createTotal.totalCount + '条'}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xl="6" >
          <div class="col_ranking">
            <div class="ranking_title" style="margin-bottom: .4rem">商机转化排名（{{successTotal.date}}）</div>
            <el-tabs>
              <el-col :span="24" class="tr">
                <div>
                  <el-date-picker
                    v-model="successTimer"
                    type="month"
                    size="mini"
                    format="yyyy 年 MM 月"
                    value-format="yyyy-MM"
                    @change="pickerDataSuccessChange"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </div>
              </el-col>
              <div class="tabs_top public">
                <span class="count" style="width: 10%">排名</span>
                <span class="count count_name" style="width: 40%">姓名</span>
                <span class="count count_num" style="width: 50%">转化数量</span>
              </div>
              <div class="m-tabs-content" >
                <div
                  v-for="(item, index) in successRanking"
                  :key="index"
                  class="tabs_top public"
                  style="border-bottom: 1px solid #eeeeee">
                  <span  class="count" style="width: 10%">{{index + 1}}</span>
                  <span  class="count count_name" style="width: 40%">{{item.create_user ? item.create_user.username : ''}}</span>
                  <span  class="count count_name" style="width: 50%">{{item.count}}</span>
                </div>
              </div>
            </el-tabs>
            <div class="tabs_position">
              <span></span>
              <span>总计:{{successTotal.totalCount + '条'}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8" :xl="6" >
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">企业续费情况（{{renewTotal.date + '年度）'}}</div>
            <el-tabs>
              <div class="tabs_top public">
                <span class="count count_name" style="width: 40%">月份</span>
                <span class="count count_num" style="width: 60%">续费数量</span>
              </div>
              <div class="m-tabs-content" style="height: 7.5rem">
                <div
                  v-for="(item, index) in renewNum"
                  :key="index"
                  class="tabs_top tabs_topBorder public">
                  <span class="count count_name" style="width: 40%">{{item.month}}</span>
                  <span class="count count_num" style="width: 60%">{{item.count}}</span>
                </div>
              </div>
              <div class="tabs_position">
                <span></span>
                <span>总计：{{renewTotal.totalCount + ' 家'}}</span>
              </div>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="ranking_list public">
      <el-row style="width: 100%"  :gutter="30">
        <el-col :span="8" :xl="6" >
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">新增企业情况（{{lastTotal.date + '年度）'}}</div>
            <el-tabs>
              <div class="tabs_top public">
                <span class="count count_name" style="width: 40%">月份</span>
                <span class="count count_num" style="width: 60%">新增数量</span>
              </div>
              <div class="m-tabs-content" style="height: 7.5rem">
                <div
                  v-for="(item, index) in lastYearNum"
                  :key="index"
                  class="tabs_top tabs_topBorder public">
                  <span class="count count_name" style="width: 40%">{{item.month}}</span>
                  <span class="count count_num" style="width: 60%">{{item.count}}</span>
                </div>
              </div>
              <div class="tabs_position">
                <span class="count count_name" style="width: 40%"></span>
                <span class="count count_num" style="width: 60%">总计：{{lastTotal.totalCount + ' 家'}}</span>
              </div>
            </el-tabs>
          </div>
        </el-col>
         <el-col :span="8" :xl="6" >
          <div class="col_ranking">
            <div class="ranking_title"  style="margin-bottom: .4rem">新增企业情况（{{thisTotal.date + '年度）'}}</div>
            <el-tabs>
              <div class="tabs_top public">
                <span class="count count_name" style="width: 40%">月份</span>
                <span class="count count_num" style="width: 60%">新增数量</span>
              </div>
              <div class="m-tabs-content" style="height: 7.5rem">
                <div
                  v-for="(item, index) in thisYearNum"
                  :key="index"
                  class="tabs_top tabs_topBorder public">
                  <span class="count count_name" style="width: 40%">{{item.month}}</span>
                  <span class="count count_num" style="width: 60%">{{item.count}}</span>
                </div>
              </div>
              <div class="tabs_position">
                <span class="count count_name" style="width: 40%"></span>
                <span class="count count_num" style="width: 60%">总计：{{thisTotal.totalCount + ' 家'}}</span>
              </div>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bussiness_stat',
  data () {
    return {

      createTimer: '',
      successTimer: '',
      createRanking: [],
      createTotal: [],
      successRanking: [],
      successTotal: [],
      lastYearNum: [],
      thisYearNum: [],
      outDestory: [],
      renewTotal: [],
      lastTotal: [],
      thisTotal: [],
      renewNum: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    pickerDataChange (val) {
      if (!val) {
        this.createTimer = ''
      } else {
        this.createTimer = val
      }
      this.handelGetCreateRanking()
    },
    pickerDataSuccessChange (val) {
      if (!val) {
        this.successTimer = ''
      } else {
        this.successTimer = val
      }
      this.handelGetSuccessRanking()
    },
    handelGetOrders () {
      this.$axios.get('/api/finance/get_header')
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.lastYearNum = data.data.lastYearNum
            this.thisYearNum = data.data.thisYearNum
            this.renewNum = data.data.renewNum
            this.outDestory = data.data.outDestory
            this.renewTotal = data.data.renewTotal
            this.thisTotal = data.data.thisTotal
            this.lastTotal = data.data.lastTotal
          }
        })
    },
    handelGetCreateRanking () {
      this.$axios.get('/api/finance/create_ranking?timer=' + this.createTimer)
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.createRanking = data.data.createRanking
            this.createTotal = data.data.createTotal
          }
        })
    },
    handelGetSuccessRanking () {
      this.$axios.get('/api/finance/success_ranking?timer=' + this.successTimer)
        .then((res) => {
          const {data} = res
          if (data.code === 0) {
            this.successRanking = data.data.successRanking
            this.successTotal = data.data.successTotal
          }
        })
    }
  },
  mounted () {
    this.handelGetOrders()
    this.handelGetCreateRanking()
    this.handelGetSuccessRanking()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .public
    display flex
    width 100%
    box-sizing border-box
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-tabs >>> .el-tabs__header
    margin-bottom 0
  .bussiness_stat
    marginLeft()
    .ranking_list
      padding .2rem
      flex-direction row
      justify-content space-between
      .col_ranking
        box-sizing border-box
        width 100%
        background: #ffffff
        box-shadow: -8px 11px 38px -10px rgba(228, 230, 235, 0.55), 3px -1px 12px 3px rgba(228, 230, 235, 0.55)
        border-radius: 10px
        padding .6rem 0.6rem 0
        height auto
        min-height 11rem
        max-height 11rem
        box-sizing border-box
        margin-bottom .6rem
        .tabs_position
          display flex
          flex-direction row
          justify-content space-between
          text-align center
          width 100%
          height 1.4rem
          line-height 1.4rem
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right

  .m-tabs-content
    height 6.5rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .tabs_top
    justify-content space-between
    flex-direction row
    padding 0 .2rem
    border-bottom 1px solid #CCCCCC
    height 1rem
    line-height 1rem
    margin-bottom .1rem
    span
      font-size .28rem
  .tabs_topBorder
    border-bottom 1px solid #eeeeee
  .tabs_topBorder:nth-last-child(1)
    border-bottom 0
  .count_name
    text-align center
  .count_num
    text-align right
  .clues_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF

  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem;

  .mt-10
    margin-top: .2rem

  .el-select, .el-cascader
    width: 100%
  .el-dropdown-link {
    cursor: pointer;
    color: #333;
    font-size .3rem
  }
  .ranking_title
    color: #333
    font-size .3rem

  .el-icon-arrow-down {
    font-size: 12px;
  }
  /*滚动条整体样式*/
  ::-webkit-scrollbar {
    width: .1rem; /*竖向滚动条的宽度*/
    height: 10px; /*横向滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track { /*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important
</style>



// WEBPACK FOOTER //
// src/pages/bussiness_stat/bussiness_stat.vue